// src/service/DescuentosAutomaticos.js
import instance from "../apis/app";

class DescuentosAutomaticosService {
  // ==========================================
  // ENDPOINTS PÚBLICOS (sin autenticación)
  // ==========================================

  // Obtener descuentos vigentes para un taller
  async GetPorTaller(tallerId, soloVigentes = true) {
    const response = await instance.get(`/taller/${tallerId}/descuentos`, {
      params: { soloVigentes }
    });
    return response.data;
  }

  // Verificar si un taller tiene descuentos activos
  async TieneDescuentos(tallerId) {
    const response = await instance.get(`/taller/${tallerId}/tiene-descuentos`);
    return response.data;
  }

  // Calcular precio con descuento
  async CalcularPrecio(tallerId, tipoPrecio, plan) {
    const response = await instance.post(`/calcular-precio`, {
      tallerId,
      tipoPrecio,
      plan
    });
    return response.data;
  }

  // Aplicar descuentos a carrito
  async AplicarACarrito(items) {
    const response = await instance.post(`/aplicar-carrito`, { items });
    return response.data;
  }

  // Validar descuentos en checkout
  async ValidarCheckout(items) {
    const response = await instance.post(`/validar-checkout`, { items });
    return response.data;
  }

  // ==========================================
  // ENDPOINTS DE ADMINISTRACIÓN (con auth)
  // ==========================================

  // Listar descuentos con filtros y paginación
  async List(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const response = await instance.get(`/descuentos${queryString ? `?${queryString}` : ''}`);
    return response;
  }

  // Obtener descuento por ID
  async Get(id) {
    const response = await instance.get(`/descuento/${id}`);
    return response.data;
  }

  // Crear descuento
  async Create(data) {
    const response = await instance.post(`/descuento`, data);
    return response.data;
  }

  // Actualizar descuento
  async Update(id, data) {
    const response = await instance.put(`/descuento/${id}`, data);
    return response.data;
  }

  // Eliminar descuento
  async Delete(id) {
    const response = await instance.delete(`/descuento/${id}`);
    return response.data;
  }

  // Toggle activo
  async ToggleActivo(id) {
    const response = await instance.patch(`/descuento/${id}/toggle`);
    return response.data;
  }

  // Obtener estadísticas
  async GetEstadisticas(descuentoId = null) {
    const params = descuentoId ? { descuentoId } : {};
    const queryString = new URLSearchParams(params).toString();
    const response = await instance.get(`/descuentos/estadisticas${queryString ? `?${queryString}` : ''}`);
    return response.data;
  }

}

export default new DescuentosAutomaticosService();
